import { FaFacebookF, FaXTwitter, FaYoutube, FaInstagram, FaPinterestP, FaTiktok, FaEnvelope } from "react-icons/fa6";
import { useContext } from "react";
import RootContext from "../context/RootContext";
import OpenNewTab from "../hooks/OpenNewTab";
import "./Footer.css"; // custom CSS file
import { NavLink } from "react-router-dom";

const Footer = () => {
  const { year } = useContext(RootContext);
  const { openInNewTab } = OpenNewTab();

  return (
    <footer className="footer bg-oxford-blue text-white pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row gy-4">

          {/* About Us */}
          <div className="col-md-3">
            <h6 className="fw-bold mb-3 text-uppercase">About Us</h6>
            <ul className="list-unstyled footer-links">
              <li>Our Story</li>
              <li>Affiliate Program</li>
              <li>Wholesale Program</li>
              <li>Press Inquiries</li>
              <li>Careers</li>
            </ul>
          </div>

          {/* Customer Support */}
          <div className="col-md-3">
            <h6 className="fw-bold mb-3 text-uppercase">Customer Support</h6>
            <ul className="list-unstyled footer-links">
              <li><NavLink to="/return-exchange" className="text-decoration-none text-white">Returns & Exchanges</NavLink></li>
              <li>Shipping Information</li>
              <li>Promo Code Lookup</li>
              <li>Gift Card Lookup</li>
              <li><NavLink to="/complain-box" className="text-decoration-none text-white">Complain Box</NavLink></li>

            </ul>
          </div>

          {/* Help Center */}
          <div className="col-md-3">
            <h6 className="fw-bold mb-3 text-uppercase">Help & Info</h6>
            <ul className="list-unstyled footer-links">
              <li><NavLink to="/earn-rewards" className="text-decoration-none text-white">Earn Rewards</NavLink></li>
              <li><NavLink to="/payment-plans" className="text-decoration-none text-white">Payment Plans</NavLink></li>
              <li><NavLink to="/store-locator" className="text-decoration-none text-white">Retail Store Locator</NavLink></li>
              <li>Help Center</li>
              <li><NavLink to="/contact" className="text-decoration-none text-white">Contact</NavLink></li>
            </ul>
          </div>

          {/* Connect With Us */}
          <div className="col-md-3">
            <h6 className="fw-bold mb-3 text-uppercase">Connect With Us</h6>
            <div className="d-flex gap-3 mb-3">
              <FaFacebookF className="social-icon" onClick={() => openInNewTab("https://www.facebook.com/")}/>
              <FaXTwitter className="social-icon" />
              <FaYoutube className="social-icon" />
              <FaInstagram className="social-icon" />
              <FaPinterestP className="social-icon" />
              <FaTiktok className="social-icon" />
            </div>
            <p className="small">
              Want $20 Off? Sign up for our Newsletter.  
              Sign up for SMS alerts and be the first to know!
            </p>
            <button className="btn btn-danger btn-sm rounded-pill">
              <FaEnvelope className="me-2" onClick={() => openInNewTab("mailto:info@kyamch.org")} /> Get in the loop!
            </button>
          </div>
        </div>

        <hr className="border-secondary my-4" />

        {/* Bottom Section */}
        <div className="text-center small">
          <p className="mb-1">
            COPYRIGHT © 2020 - {year} ALL RIGHTS RESERVED BY <span className="fw-bold text-info">{process.env.REACT_APP_NAME}</span>
          </p>
          <p className="mb-0">
            DESIGNED & DEVELOPED BY{" "}
            <span
              className="text-decoration-underline cursor-pointer text-info"
              onClick={() => openInNewTab("https://miltonhossain.netlify.app/")}
              title="Visit APP CANVAS"
            >
              APP CANVAS
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
